import axios from 'axios'
import QS from 'qs'
import { Toast } from 'cube-ui'
import router from '@/router'

const loading = Toast.$create({
  txt: '请稍后...',
  mask: true
})

// 环境的切换
const urlMap = {
  development: '/api',
  // development: 'http://partner.warmdoctor.cn'
  // production: 'http://partner.warmdoctor.cn' // 生产

  production: 'https://partner.warmdoctor.cn' // 测试
}
const baseUrl = urlMap[process.env.NODE_ENV]

export default function createAxios () {
  const service = axios.create({
    baseURL: baseUrl, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 5000 // request timeout
  })

  // service.defaults.headers.post['Content-Type'] = 'application/json'

  /**
   * 拦截请求
   *
  */
  service.interceptors.request.use(
    config => {
      loading.show()
      return config
    },
    err => {
      loading.hide()
      return Promise.reject(err)
    }
  )

  /**
    * 设置拦截器，interceptors 的 响应处理，
    * 所有使用 axios 的请求响应,
    * 在正确返回的情况下都会 优先 进入 第一个回调方法，
    * 在有错误的情况下，都会 优先 进入第二个回调方法。
    */
  service.interceptors.response.use((response) => {
    // 统一处理数据，使组件中的请求只获取到需要的业务数据
    loading.hide()
    return response.data
  }, (error) => {
    console.log(error)
    loading.hide()
    // 处理错误的响应
    Toast.$create({
      type: 'txt',
      time: 10000,
      txt: '网络拥堵\n请切换网络后尝试'
    }).show()
    return Promise.reject(error)
  })

  return service
}
